import './style.css'


function CustomBox({ children, style = {} }) {
    return (
        <div className="box-container" style={style}>
            {children}
        </div>
    )
}

export default CustomBox